import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const ContentContext = createContext({});

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [services, setServices] = useState(null);
  const [jobs, setJobs] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/api/content`).catch(() => ({ data: {} })),
      axios.get(`${API}/api/services`).catch(() => ({ data: [] })),
      axios.get(`${API}/api/jobs`).catch(() => ({ data: [] })),
    ]).then(([c, s, j]) => {
      setContent(c.data);
      setServices(s.data);
      setJobs(j.data);
      setLoaded(true);
    });
  }, []);

  return (
    <ContentContext.Provider value={{ content, services, jobs, loaded }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
